import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UnidadAdministrativaRepository } from 'src/app/domain/service/unidad-administrativa/unidad-administrativa-repository';
import { validarSize } from 'src/app/common/validation-utils';
import {
  UnidadAdministrativaFiltro,
  UnidadAdministrativaPageResponse
} from '@model/unidad-administrativa/unidad-administrativa';

/**
 * Adaptador HTTP: HttpUnidadAdministrativaRepository
 *
 * Implementa el puerto UnidadAdministrativaRepository para comunicación HTTP con backend.
 * Realiza llamadas REST al backend Spring Boot (UnidadAdministrativaController).
 *
 * Arquitectura Hexagonal:
 * - Este adaptador está en infraestructura
 * - Implementa el puerto UnidadAdministrativaRepository del dominio
 *
 * Backend: 580-girop_servicios-ms (puerto 8080)
 *
 * @author Sura - Migración GWT a Spring Boot
 */
@Injectable({ providedIn: 'root' })
export class HttpUnidadAdministrativaRepository implements UnidadAdministrativaRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/unidades-administrativas`;

  async buscarUnidadesAdministrativas(
    filtro: UnidadAdministrativaFiltro,
    cursor: string | null,
    size: number,
    direction: 'NEXT' | 'PREVIOUS' | 'LAST'
  ): Promise<UnidadAdministrativaPageResponse> {
    validarSize(size);
    let params = new HttpParams();

    if (filtro.codigo) {
      params = params.set('codigo', filtro.codigo);
    }
    if (filtro.nombre) {
      params = params.set('nombre', filtro.nombre);
    }
    if (filtro.nmconsecutivoCliente) {
      params = params.set('nmconsecutivoCliente', filtro.nmconsecutivoCliente.toString());
    }
    params = params.set('size', size.toString());
    if (cursor) {
      params = params.set('cursor', cursor);
    }
    params = params.set('direction', direction);

    return firstValueFrom(
      this.http.get<UnidadAdministrativaPageResponse>(
        `${this.baseUrl}/search`,
        { params }
      )
    );
  }
}
